

import styled from "styled-components"
import paketlemeTypes from "../../../../utils/yukOptions/paketlemeTypesOptions";
import formatConverter from "../../../../helper/formatConverter";

const Container = styled.div`
  font-weight: var(--font-weight-sm);
  font-size: var(--font-size-sm);
  color: ${({theme}) => theme.mainTextColor};

  h4{
    font-weight: var(--font-weight-lg);
    font-size: var(--font-size-sm);
    color: ${({theme}) => theme.mainTextColor};
  }

.list{
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 30px;
  width: 70%;
  gap: 10px;

  .list-item{
    display: flex;
    flex-direction: column;
  }

  .paketleme-list-item{
    display: flex;

    .paketleme-name{
      padding-right: 5px;
    }

    .paketleme-quantity{
      padding-left: 5px;
    }
  }
}

  .seperator{
    width: 100%;
    height: 1px;
    background-color: ${({theme}) => theme.contrastBorderColor};
  }
`


const YukDetails = ({yukData, paketlemeData}) => {
  return (
    <Container>
        <h4 className="title">Yük</h4>
        <div className="list">
            {
                yukData?.yuklemeTuru?.text &&
                <div className="list-item">{yukData?.yuklemeTuru?.text}</div>
            }
            {
                yukData?.yukTuru &&
                <div className="list-item">{yukData?.yukTuru}</div>
            }
            {
                (yukData?.toplamAgirlik || yukData?.agirlikBirim?.text || yukData?.toplamHacim) &&
                <div className="list-item">{yukData?.agirlikBirim?.value !== 3 && yukData?.toplamAgirlik} {yukData?.agirlikBirim?.text}{(yukData?.agirlikBirim?.text && yukData?.toplamHacim) && "/"}{yukData?.toplamHacim &&  `${yukData?.toplamHacim} Metreküp`}</div>
            }
            {
                paketlemeData?.length > 0 &&
                    paketlemeData?.map((item) => (
                      <div key={item.id ?? item.activePaketlemeTypeId}>
                        {
                          item?.list?.map((subItem) => (
                            <div className="paketleme-list-item" key={subItem.id ?? `${subItem.en}-${subItem.boy}-${subItem.sayisi}`}>
                              <span className="paketleme-name">{paketlemeTypes.find(innerItem => innerItem.id === item.activePaketlemeTypeId)?.name ?? item.paketlemeType ?? "Paketleme"}</span>
                              (
                                <span>{subItem?.en}</span>
                                <span>{((subItem?.en || "") && subItem?.boy) && "x"}{subItem?.boy || ""}</span>
                                <span>{((subItem?.boy || "") && (subItem?.yukseklik || "")) && "x"}{(subItem?.yukseklik || "")}</span>
                                <span>{subItem?.agirlik || ""}</span>
                              )
                                <span className="paketleme-quantity">{subItem?.sayisi || "1"}{ " Adet"}</span>
                            </div>
                          ))
                        }
                      </div>
                    ))
            }
            {
                yukData?.yukunDegeri &&
                <div className="list-item">{yukData?.yukunDegeri && `Sigorta Değeri ${formatConverter(yukData?.yukunDegeri, 0)} TL`}</div>
            }
            {
                yukData?.yukDesc &&
                <div className="list-item">{yukData?.yukDesc}</div>
            }
        </div>
        <div className="seperator"/>
 </Container>
  )
}

export default YukDetails
